var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAtSign = function SvgAtSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "2 1.5 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.748 6.417h1.834V11c0 2.265.173 2.75.916 2.75 1.196 0 1.834-.565 1.834-2.75 0-4.849-2.432-7.333-7.334-7.333A7.333 7.333 0 1 0 15.3 16.94l1.075 1.485a9.167 9.167 0 1 1-5.377-16.592c5.923 0 9.167 3.315 9.167 9.167 0 3.25-1.504 4.583-3.667 4.583-1.232 0-1.937-.397-2.324-1.279a4.583 4.583 0 1 1-.426-6.97v-.917ZM13.75 11a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Z",
    fill: "currentColor"
  })));
};
export default SvgAtSign;